import { render, staticRenderFns } from "./ViewWrapper.vue?vue&type=template&id=476523f7&scoped=true"
import script from "./ViewWrapper.vue?vue&type=script&lang=js"
export * from "./ViewWrapper.vue?vue&type=script&lang=js"
import style0 from "./ViewWrapper.vue?vue&type=style&index=0&id=476523f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476523f7",
  null
  
)

export default component.exports